import type { EnumValue } from '../utils/utility.types';

export const AuthType = {
    Internal: 'INTERNAL',
    Saml: 'SAML',
    Ldap: 'LDAP',
    friendlyString(entry: string) {
        const map = {
            [this.Internal]: 'CloudConnexa',
            [this.Saml]: 'SAML',
            [this.Ldap]: 'LDAP',
        } as const;

        return map[entry as unknown as keyof typeof map] || entry;
    },
} as const;

export const UserRoleType = {
    Member: 'MEMBER',
    Owner: 'ENROLLED_OWNER',
    PendingOwner: 'OWNER',
    Admin: 'PRODUCT_ADMIN',
    GlobalConfigAdmin: 'G_CONFIG_ADMIN',
    BillingAdmin: 'BILLING_ADMIN',
    GlobalBillingAdmin: 'G_BILLING_ADMIN',
} as const;

export type AuthTypeValue = EnumValue<typeof AuthType>;

export type UserRoleTypeValue = EnumValue<typeof UserRoleType>;
